enum PaySlipTransportSetting {
  EBoks = 'EBoks',
  MitDK = 'MitDK',
  EMail = 'EMail',
  SMS = 'SMS',
}
export default PaySlipTransportSetting
